import React, { useCallback, useMemo } from 'react';
import { Table } from 'tea-component';
import { CONSTANT_TEXTS } from '@gp/constants/const';
const { autotip } = Table.addons;

function useTableStatus({
  loading = false,
  error = '', // 超时状态
  dataSource = [],
  operat = () => {}, // 操作
  clearResultText = 'Back',
  // 是否使用Reset无数据提示内容
  isUseResetNodata = false,
}) {
  const operateFn = useCallback(
    (flag) => {
      operat(flag);
    },
    [operat],
  );

  // noData文案设置-最新统一foundTextCur
  const foundTextCur = useMemo(() => {
    if (isUseResetNodata) {
      return (
        <div className="dbg-nodata-div">
          <span className="dbg-nodata-normal-span">{`No data found for the selected filters. Please adjust your filters or click '`}</span>
          <span className="dbg-nodata-reset-a-span" onClick={() => operateFn('reset')}>
            {'Reset'}
          </span>
          <span className="dbg-nodata-normal-span">{`' to turn all filters off.`}</span>
        </div>
      );
    }
    return <span>{CONSTANT_TEXTS.SORRY_EMPTY_TEXT}</span>;
  }, [isUseResetNodata, operateFn]);

  // noData文案设置-最新统一clearResultTextCur
  const clearResultTextCur = useMemo(() => {
    if (isUseResetNodata) {
      return ' ';
    }
    return clearResultText;
  }, [isUseResetNodata, clearResultText]);

  const param = {
    isLoading: loading,
    isError: !loading && Boolean(error),
    isFound: !loading && Boolean(dataSource?.length === 0),
    // 超时状态
    hideIcon: !loading, // loading状态显示图标，其他情况不显示
    errorText: <span style={{ color: '#444' }}>Loading failed,please try</span>,
    retryText: <span style={{ color: '#326ff0' }}>again</span>,
    onRetry: () => operateFn('again'), // 重新搜索一次
    // 未找到状态
    foundText: foundTextCur,
    clearResultText: clearResultTextCur,
    onClear: () => operateFn('back'), // 返回上一次搜索记录
    style: { height: 200, lineHeight: '200px' },
  };

  return autotip(param);
}

export default useTableStatus;
